module.exports = __webpack_public_path__ + "static/media/skin-beauty-three@2x.29d8825e.png";